import { render } from "./CermiToken.vue?vue&type=template&id=78c2e4fc&scoped=true"
import script from "./CermiToken.vue?vue&type=script&lang=js"
export * from "./CermiToken.vue?vue&type=script&lang=js"

import "./CermiToken.vue?vue&type=style&index=0&id=78c2e4fc&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c2e4fc"]])

export default __exports__